import { apiFetch } from '../api/client';

import { setViewAsSalesRepFlag } from './viewAsStorage';

/**
 * T-VIEW-AS — enter/exit actions for superAdmin "View As Sales Rep".
 *
 * The MSAL token cache is NEVER touched: the real superAdmin JWT stays put;
 * impersonation is carried entirely by the per-tab session flag + the
 * `X-View-As-Role` request header.
 */

/**
 * Enter View As Sales Rep. POSTs the audit bookend FIRST, THEN sets the per-tab
 * flag — ordering matters: the enter request must run as the real superAdmin
 * (no `X-View-As-Role` header yet), or the server would downscope it and the
 * superAdmin-gated endpoint would reject. The caller invalidates `/me/profile`
 * afterward so the nav re-renders as salesRep.
 */
export async function enterViewAsSalesRep(): Promise<void> {
  await apiFetch('/api/v1/me/view-as', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ role: 'salesRep' }),
  });
  setViewAsSalesRepFlag(true);
}

/**
 * Exit View As — CLIENT-AUTHORITATIVE. Best-effort POSTs the exit audit
 * bookend, but ALWAYS clears the per-tab flag so the superAdmin is restored
 * even if the endpoint errors (no-lockout). We intentionally do NOT inspect the
 * response: a 5xx (resolved) and a network error (thrown) both fall through to
 * the flag clear. No re-auth; MSAL untouched. The caller invalidates
 * `/me/profile` afterward so the nav re-renders as the real superAdmin.
 */
export async function exitViewAsSalesRep(): Promise<void> {
  try {
    await apiFetch('/api/v1/me/view-as/exit', { method: 'POST' });
  } catch {
    // Network failure — restore anyway. The flag clear below is what matters.
  }
  setViewAsSalesRepFlag(false);
}
